import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { updateDimmed, updateLoginVisible, updateSignupVisible, updateContactVisible } from "../../../features/forms/formsSlice"
import { logout, clearAuthError, clearSignupSuccess } from "../../../features/auth/authSlice";
import { PreWrapper, Image, Wrapper, TextButtonsWrapper, Header, Subheader, ButtonsWrapper, ColorLayer, SignUp, LogIn, ImageWrapper } from "./HomeSection1Styles"
import homeImage from "./01_images/home.jpg"
import Svg from "./Svg"
import LoginForm from "./02_forms/LoginForm"
import SignupForm from "./02_forms/SignupForm"
import ContactForm from "../../../components/03_footer/01_contactform/ContactForm"
import ResetPassword from "./02_forms/ResetPassword";
import { home } from "../../../i18n/02_home"
import ImageWithLoader from "../../../components/04_common/04_inlineLoader/ImageWithLoader";

const HomeSection1 = ({ resetPasswordMode }) => {

  const [homeSectionDimmed, setHomeSectionDimmed] = useState(false)
  const [footerDimmed, setFooterDimmed] = useState(false)

  const loginVisible = useSelector(state => state.forms.loginVisible)
  const signupVisible = useSelector(state => state.forms.signupVisible)
  const contactVisible = useSelector(state => state.forms.contactVisible)

  const lang = useSelector(state => state.lang.lang)
  const t = home[lang]

  const auth = useSelector(state => state.auth?.user?.role)

  const dispatch = useDispatch()

  const makeLoginVisible = (e) => {
    e.preventDefault()
    dispatch(updateLoginVisible(true))
    dispatch(updateDimmed(true))
    console.log(auth)
  }

  const makeSignupVisible = (e) => {
    e.preventDefault()
    if (auth === "ADMIN") {
      dispatch(updateSignupVisible(true))
      dispatch(updateDimmed(true))
      return
    }
    dispatch(updateContactVisible(true))
    dispatch(updateDimmed(true))
  }

  const logOut = (e) => {
    e.preventDefault()
    dispatch(logout());
    dispatch(clearAuthError());
    dispatch(clearSignupSuccess());
  }

  useEffect(() => {
    if (resetPasswordMode) {
      dispatch(updateDimmed(true));
    }
  }, [resetPasswordMode, dispatch]);

  return (
    <PreWrapper>
      <LoginForm
        loginVisible={loginVisible}
      />
      <SignupForm
        signupVisible={signupVisible}
        homeSectionDimmed={homeSectionDimmed}
      />
      <ContactForm
        contactVisible={contactVisible}
        footerDimmed={footerDimmed}
      />
      <ResetPassword
        resetPasswordVisible={resetPasswordMode}
      />
      <Wrapper
        homeSectionDimmed={homeSectionDimmed}
      >
        <ImageWrapper>
          <ImageWithLoader src={homeImage} loaderLabel="Loading…" />
        </ImageWrapper>
        <Svg />
        <ColorLayer />
        <TextButtonsWrapper>
          <Header>{t.one_header}</Header>
          <Subheader>{t.one_subheader}</Subheader>
          <ButtonsWrapper>
            {
              (auth === "ADMIN" || auth === undefined) &&
              <SignUp
                onClick={makeSignupVisible}
              >{t.one_signup}</SignUp>
            }
            {
              auth === undefined
                ?
                <LogIn
                  onClick={makeLoginVisible}
                >
                  {t.one_login}
                </LogIn>
                :
                <LogIn
                  onClick={logOut}
                >
                  {t.one_logout}
                </LogIn>
            }
          </ButtonsWrapper>
        </TextButtonsWrapper>
      </Wrapper>
    </PreWrapper>
  )
}


export default HomeSection1